const initialState = {
    data: null,
    fetch: {
      done: false,
      loading: false,
      error: null,
    },
  };
  export { initialState };
  